import React, { useState } from 'react'
import { SubProjectLineProps } from './SubProjectLine.types'
import styles from './SubProjectLine.module.scss'
import cl from 'classnames'
import { Button, ImagePortrait, Text1 } from 'components/shared'
import { getMainImageSrcForObj } from 'utilities'
import { IconArrowRight, IconCollapse, IconExpand } from 'assets'
import { inject } from 'mobx-react'
import { GENERAL_STORE } from 'store'

const SubProjectLineComponent = (props: SubProjectLineProps) => {
  const {
    project,
    style,
    className,
    [GENERAL_STORE]: {
      push
    }
  } = props

  const isExpandable = Boolean(project.children && project.children.length)
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <>
      <div
        className={cl(styles.subProjectLine, className)}
        style={style}
      >
        <ImagePortrait
          width={26}
          src={getMainImageSrcForObj(project)}
          style={{ marginRight: 25 }}
        />
        {isExpandable && (
          <Button
            preset='icon'
            style={{ marginRight: 5 }}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded
              ? <IconCollapse fill={styles.secondaryContent} />
              : <IconExpand fill={styles.secondaryContent} />
            }
          </Button>
        )}
        <Text1 bold>
          {project.name}
        </Text1>
        <Button
          preset='icon'
          className={styles.arrowButton}
          onClick={() => push(`/projects/edit/${project.id}`)}
        >
          <IconArrowRight />
        </Button>
      </div>

      {isExpanded && project.children.map((p, index) => {
        const isLast = index === project.children.length - 1

        return (
          <SubProjectLine
            key={p.id}
            project={p}
            style={{
              paddingLeft: 50,
              marginBottom: isLast ? 20 : undefined
            }}
          />
        )
      })}
    </>
  )
}

const SubProjectLine = inject(GENERAL_STORE)(SubProjectLineComponent)
export { SubProjectLine }
